import Icons from "@/src/components/Icons";
interface ordersProps {
  data: any;
  onClick: any;
}
import moment from "jalali-moment";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { hasChefVisibleDescription } from "@/src/utils/helpers";

function OrdersItem({ data, onClick }: ordersProps) {
  const hasDescription = hasChefVisibleDescription(data);

  return (
    <>
      <div
        className={`item rounded-xl shadow-mmpz min-h-[78px] border p-3 relative cursor-pointer ${
          hasDescription ? "border-error" : "border-gray-100-mmpz"
        }`}
        onClick={onClick}
      >
        <div className="flex items-center justify-start gap-1 pe-10">
          {hasDescription && (
            <span className="inline-flex shrink-0 origin-center animate-alarm">
              <Icons name="warningAlarm" size={20} />
            </span>
          )}
          <h6 className="text-lg font-bold max-one-line w-fit">{data.name}</h6>
        </div>
        {hasDescription && (
          <p className="text-error text-sm text-right mt-1 pe-10">
            (دارای توضیحات)
          </p>
        )}
        <div className="rounded shadow-mmpz flex gap-4 items-center w-fit p-2 mt-2">
          <span className="flex items-center gap-2 text-sm">
            <Icons name="time" size={18} />{" "}
            {digitsEnToFa(moment(data.deliveryDate).format("HH:mm"))}
          </span>
          <span className="flex items-center gap-2 font-bold text-gray-200-mmpz text-sm">
            <Icons name="date" size={18} fill="none" />
            {digitsEnToFa(moment(data.deliveryDate).format("jYYYY-jMM-jDD"))}
          </span>
        </div>
        <span className="absolute top-2 left-2">
          <Icons name="moreIcon" size={30} />
        </span>
      </div>
    </>
  );
}

export default OrdersItem;
